import { Component } from '@angular/core';
import { CardComponent } from '../../../atoms/card/card/card.component';

@Component({
  selector: 'app-forbidden',
  templateUrl: './forbidden.component.html',
  imports: [CardComponent],
})
export class ForbiddenComponent {}
